<template >
    <div id="tabbed-container">
        <div id="tabbed-header" class="tabbed-header">
            <div 
                class="tab-name"
                :class="{ active: tab.active}"
                v-for="(tab, index) in tabs" 
                :key="tab['tab-name']" 
                :tab-name="tab['tab-name']"
                @click="activateTab(index)"
            >
                {{tab.title}}
            </div>
        </div>
        <div id="tabbed-content">
            <tab-content>
                <slot/>
            </tab-content>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'

const TabInstance = Vue.component('tab', {
	props: ['currentTab'],
    template: 
    `<div v-show="currentTab">
      <p><slot/></p>
    </div>`
});

const ActiveTabContainer = Vue.component('tab-content', {
	render(h) {
        let toRenderSlot = this.$slots.default.find(vNode => {
            return vNode.tag &&
                vNode.componentOptions &&
                vNode.data.attrs.active;
        }) || {};

        if(toRenderSlot && toRenderSlot.componentOptions){
            toRenderSlot = toRenderSlot.componentOptions.children;
        }

        return toRenderSlot;
    }
});

const activateTab = function(tabIndex){
    this.tabs.forEach((tab, index)=>{
        tab.active = index == tabIndex;
    });

    this.$forceUpdate();
};

export default {
    name:"TabbedContainerComponent",
    components:{
        'tab-content':ActiveTabContainer,
        'tab':TabInstance
    },
    data(){
        return {
            tabs:this.$slots.default.filter(slot=>slot.tag).map(slot=>slot.data.attrs)
        }
    },
    created(){
        let activeTab = this.tabs.find(tab=>tab.active);
        if(!activeTab){
            this.tabs[0].active = true;
        }
    },
    mounted(){
        // activateTab.call(this, 0);
    },
    methods:{
        activateTab: activateTab
    },
}
</script>

<style lang="less" scoped>
    .tabbed-header{

        text-align: left;

        .tab-name{
            display: inline-block;
            margin: 5px;
            &.active{
                border-bottom: 5px solid fuchsia;
            }
        }
    }
</style>